<template>
  <div id="GuestArriveDialog_main">
    <el-dialog
      custom-class="GuestArriveDialog_dialog"
      :modal="mode3 ? false : true"
      :visible.sync="dialogVisible"
      width="60%"
      @opened="openDialog"
      @close="closeDialog"
    >
      <div slot="title">
        <span class="title">訪客押件和門禁</span>
        <span class="tip">若此部分無需登記，請直接按完成登記</span>
      </div>
      <div class="left">
        <el-form
          label-position="top"
          label-width="80px"
        >
          <el-form-item label="抵押證件（非必填）">
            <el-select
              v-model="requestData.idCardId"
              placeholder="請選擇"
              :disabled="!userCheckWebCamAuthority"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="選擇門禁">
            <el-button
              :type="requestData.carrierCode !== '' ? 'primary' : 'default'"
              :disabled="!userCheckWebCamAuthority"
              round
              @click="ReadNFCBarcode"
            >
              感應門禁卡
            </el-button>
            <el-button
              v-if="qrcodeEnableWeb"
              :disabled="!userCheckWebCamAuthority"
              round
              @click="printQRcode"
            >
              列印取得門禁QR Code
            </el-button>
          </el-form-item>
        </el-form>
        <el-button
          type="primary"
          :disabled="!userCheckWebCamAuthority"
          round
          @click="webCamReady"
        >
          完成登記
        </el-button>
      </div>
      <div class="right">
        <div
          v-if="!userCheckWebCamAuthority"
          class="webcamTip"
        >
          <p>網路攝影機 載入中...</p>
          <p>請選擇相機權限</p>
        </div>
        <WebCam
          ref="webcam"
          :fixed="true"
          :onside="false"
          @takephoto="takephoto"
        />
      </div>
    </el-dialog>
    <ReadNFCBarcode ref="reader" />
    <GuestQRCodeDialog ref="GuestQRCodeDialog" />
  </div>
</template>
<script>
import ReadNFCBarcode from '@/components/ReadNFCBarcode'
import WebCam from '@/components/WebCam'
import GuestQRCodeDialog from '../components/GuestQRCodeDialog'
import { createBroadcastChannel } from '@/js/utils/broadcastChannelHelper'
import { confirmGuestReservationStatus } from '@/js/utils/guest'

export default {
  components: {
    ReadNFCBarcode,
    WebCam,
    GuestQRCodeDialog
  },
  props: {
    qrcodeEnableWeb: Boolean
  },
  data () {
    return {
      dialogVisible: false,
      mode: 0, // 1:有GuestId的訪客抵達 、 2:沒有GuestId的訪客抵達，訪客資料建立＋抵達
      mode3: false, // true:瀏覽器推播的訪客，流程使用mode=1
      guestId: '', // 僅情境一使用
      mode2Data: {}, // 僅情境二使用
      mode2ClickPrint: false, // 僅情境二使用，click[列印門禁QRCode]後需在此訪客登記成功後，取得訪客QRCode
      QRcodeData: {}, // 紀錄QRCode資料
      requestData: { // 共用
        carrierCode: '',
        webcamImageUrl: '',
        idCardId: ''
      },
      options: [],
      showNFCBarcode: false,
      webCamIsReady: false, // webCam初始化成功後-true
      waitWebCamReady: null, // 等待webCam初始化計時器
      notOpenWebCam: false,
      userCheckWebCamAuthority: false, // 使用者回覆webcam權限（無論封鎖或允許）-true
      guestChannel: null, // 廣播頻道
      fullScreenLoadingInstance: null, // 保存 fullScreenLoading 實例以便正確關閉
      fullScreenLoadingCount: 0 // fullScreenLoading 開啟次數計數，避免重複實例殘留
    }
  },
  mounted () {
    // 設定廣播頻道
    this.guestChannel = createBroadcastChannel('guest')
  },
  beforeDestroy () {
    if (this.guestChannel) {
      this.guestChannel.destroy()
    }
    // 保險收斂所有可能殘留的 loading
    if (this.fullScreenLoadingInstance) {
      this.fullScreenLoadingInstance.close()
      this.fullScreenLoadingInstance = null
      this.fullScreenLoadingCount = 0
    }
  },
  methods: {
    // 開啟彈窗 情境一：有GuestId的訪客抵達 ＝ 在「即將抵達訪客列表」中的訪客click[確認訪客抵達]
    guestArrive (id, QRcode) {
      this.mode = 1
      this.guestId = id
      this.QRcodeData = QRcode
      this.dialogVisible = true
      if (this.$route.params.guestId !== 'List') { this.mode3 = true }
    },
    // 開啟彈窗 情境二：沒有GuestId的訪客抵達 ＝ 管理員現場登記
    guestCreateAndArrived (data) {
      this.mode = 2
      this.mode2ClickPrint = false
      this.mode2Data = data
      console.log('情境二資料', this.mode2Data)
      this.dialogVisible = true
    },
    // [共用] 取得門禁卡資料，取得後直接登記並關閉彈窗
    ReadNFCBarcode () {
      this.showNFCBarcode = true
      this.$refs.reader.getCode((code) => {
        this.$refs.reader.close()
        this.requestData.carrierCode = code
        this.webCamReady()
      }, 'NFC')
    },
    // [共用] 列印門禁QRCode button 分流
    printQRcode () {
      this.fullScreenLoading(true)
      if (this.mode === 1 && this.QRcodeData !== null) { // 情境一訪客，且有QRCode
        this.webCamReady() // 登記
        const QRcodeData = {
          startAt: this.$newFormatDate(this.QRcodeData.StartAt),
          dueAt: this.$newFormatDate(this.QRcodeData.DueAt),
          code: this.QRcodeData.Code
        }
        this.$refs.GuestQRCodeDialog.onlyPrintQRcode(QRcodeData)
      } else if (this.mode === 1 && this.QRcodeData === null && this.guestId) { // 情境一訪客，但沒有QRCode
        this.webCamReady() // 登記
        this.$refs.GuestQRCodeDialog.creatAndPrintQRcode(this.guestId)
      } else if (this.mode === 2) {
        this.webCamReady()
        this.mode2ClickPrint = true
      }
    },
    // 確認webCam已開啟
    async webCamReady () {
      const isFinished = await confirmGuestReservationStatus(this.guestId, this.mode3)
      if (isFinished) {
        this.guestChannel.postMessage({ type: 'deleteItem', data: { id: this.guestId } }) // 刪除推播項目
        this.guestChannel.postMessage({ type: 'reload' }) // 使其他頁面重新整理
        this.dialogVisible = false
        return
      }

      this.fullScreenLoading(true)

      /**
       * 避免當攝影機初始化或其他非預期狀況發生導致 loading 卡住，所以設定逾時後關閉
       */
      const timeoutMs = 1000 * 10
      const timeoutId = setTimeout(() => {
        if (this.waitWebCamReady) {
          clearInterval(this.waitWebCamReady)
          this.waitWebCamReady = null
          this.fullScreenLoading(false)
          this.$message.warning(this.$t('GuestArriveDialog.WebCamTimeout'))
        }
      }, timeoutMs)

      this.waitWebCamReady = setInterval(() => {
        if (this.notOpenWebCam) { // 未開啟webcam權限
          clearTimeout(timeoutId)
          this.autoRegister()
          clearInterval(this.waitWebCamReady)
          this.waitWebCamReady = null
        } else if (this.webCamIsReady && this.requestData.webcamImageUrl !== '') { // 有開啟webcam權限
          clearTimeout(timeoutId)
          this.autoRegister()
          clearInterval(this.waitWebCamReady)
          this.waitWebCamReady = null
        }
      }, 100)
    },
    // 取得webcam檔案，並做登記API分流
    async autoRegister () {
      try {
        if (!this.notOpenWebCam) { // 有開啟webcam權限
          if (kingetcareFb === null) {
            this.$alert(this.$t('GuestArriveDialog.ExecutionFailed'), '', {
              confirmButtonText: '確定',
              callback: action => {}
            })
            this.fullScreenLoading(false)
            return
          }
          await new Promise((resolve, reject) => {
            this.$base64Decode(this.requestData.webcamImageUrl, bs64 => {
              this.$uploadFileToFirebase({ file: bs64, folder: 'webcam', bucketName: 'kingnetcare' }, img_url => {
                // eslint-disable-next-line eqeqeq
                if (img_url != 'error') {
                  this.requestData.webcamImageUrl = img_url
                  resolve()
                } else {
                  reject(new Error('影像上傳失敗'))
                }
              })
            })
          })
        }
        if (this.mode === 1) { this.postGuestArrive() } else if (this.mode === 2) { this.postGuestCreateAndArrived() }
      } catch (e) {
        // 上傳影像等流程失敗時，顯示錯誤訊息並關閉 loading
        console.error(e)
        this.$alert(`${this.$t('GuestArriveDialog.AutoRegisterFailed')}`, '', {
          confirmButtonText: '確定'
        })
        this.fullScreenLoading(false)
      }
    },
    // 情境一的訪客抵達登記API
    postGuestArrive () {
      const queryPath = {
        id: this.guestId
      }
      const requestData = this.requestData
      apiGuest.PlusGuestReservation.PostArrivedInfo(
        queryPath,
        requestData
      ).then((res) => {
        if (res.status === 200) {
          this.$emit('getList')
          this.finishSubmit()
        }
      }).catch((err) => {
        if (err.response.status) {
          if (err.response.status === 400) { this.alert('訪客已登記抵達') } else { this.alert('訪客登記抵達失敗，請稍後再試') }
          if (this.$route.params.guestId === 'List') { this.$emit('getList') }
        }
        console.log('錯誤訊息：', err.response)
      })
    },
    // 情境二的訪客抵達登記API
    async postGuestCreateAndArrived () {
      console.log('postGuestCreateAndArrived')
      const time = await this.getQRCodeTime()
      const requestData = {
        guestName: this.mode2Data.guestName,
        cause: this.mode2Data.cause,
        tabletId: this.mode2Data.tabletId,
        cellPhone: this.mode2Data.cellPhone,
        licensePlateNumber: this.mode2Data.licensePlateNumber,
        remark: this.mode2Data.remark,
        carrierCode: this.requestData.carrierCode,
        webcamImageUrl: this.requestData.webcamImageUrl,
        idCardId: this.requestData.idCardId === '' ? null : this.requestData.idCardId
      }
      if (this.qrcodeEnableWeb) {
        requestData.qRcode = {
          startAt: `${time.startAt.replace(' ', 'T')}.000Z`,
          dueAt: `${time.dueAt.replace(' ', 'T')}.000Z`
        }
      }
      console.log(requestData)
      apiGuest.PlusGuestReservation.PostCreateAndArrived(
        requestData
      ).then((res) => {
        this.fullScreenLoading(false)
        if (res.status === 200) {
          if (!this.mode2ClickPrint) { // 非click[列印門禁QRCode] 直接顯示登記完成alert即可
            this.finishSubmit()
          } else {
            this.fullScreenLoading(true)
            this.getGuestData(res.data)
          }
        }
        this.$emit('guestCheckInInit')
      }).catch((err) => {
        if (err.response.data === 'QrCode is null') {
          // 無卡機戶別無法生成QR code
          this.alert('訪客登記修改失敗，沒有該戶別資料')
          return
        }

        this.alert('訪客登記失敗，請稍後再試')

        console.log('錯誤訊息：', err.response)
      })
    },
    // 取得QRCode有效時間
    getQRCodeTime () {
      return new Promise((resolve, reject) => {
        const now = new Date()
        let nowData = ''
        if (now.getMinutes() % 5 === 0) {
          nowData = `${this.$newFormatDate(now).slice(0, 17) + '00'}`
        } else {
          const interval = parseInt(now.getMinutes() / 5) + 1
          const min = interval * 5
          if (min === 60) { // 56-60分時，進位到下一個小時
            const now2 = now.getTime() + 5 * 60 * 1000
            nowData = `${this.$newFormatDate(now2).slice(0, 14) + '00:00'}`
          } else {
            nowData = `${this.$newFormatDate(now).slice(0, 14) + (('0' + (min)).slice(-2)) + ':00'}`
          }
        }
        const nowLongData = new Date(nowData).getTime()
        const newtime = {
          startAt: this.$newFormatDate(nowLongData - 30 * 60 * 1000 - 8 * 60 * 60 * 1000),
          dueAt: this.$newFormatDate(nowLongData + 30 * 60 * 1000 - 8 * 60 * 60 * 1000)
        }
        resolve(newtime)
      })
    },
    // 取得訪客資料
    getGuestData (guestId) {
      console.log('getGuestData', guestId)
      const requestData = {
        id: guestId
      }
      apiGuest.PlusGuestReservation.GetGuestData(
        requestData
      ).then((res) => {
        console.log(res)
        if (res.status === 200) {
          const QRcodeData = {
            startAt: this.$newFormatDate(res.data.QRcode.StartAt),
            dueAt: this.$newFormatDate(res.data.QRcode.DueAt),
            code: res.data.QRcode.Code
          }
          console.log(QRcodeData)
          this.$refs.GuestQRCodeDialog.onlyPrintQRcode(QRcodeData)
          this.finishSubmit()
        } else {
          this.$message.error('取得QRCode失敗，無法列印，訪客將直接進場')
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // [共用] 登記成功 msgbox
    finishSubmit () {
      this.guestChannel.postMessage({ type: 'deleteItem', data: { id: this.guestId } }) // 刪除推播項目
      this.guestChannel.postMessage({ type: 'reload' }) // 使其他頁面重新整理
      this.fullScreenLoading(false)
      this.dialogVisible = false
      this.$msgbox({
        title: '訪客登記成功',
        customClass: 'message-box-alert',
        message: this.$createElement('p', null, [
          this.$createElement('p', null, '已完成此訪客登記'),
          this.$createElement('hr', null, '')]),
        showCancelButton: false,
        roundButton: true,
        confirmButtonText: '確定'
      }).then(() => {
        this.$router.push({ name: 'GuestRecord' })
        if (this.mode3) {
          window.opener = null
          window.close()
        }
      }).catch(() => {})
    },
    // [共用] 開啟彈窗時的回調
    openDialog () {
      this.notOpenWebCam = false
      this.$refs.webcam.init().then(res => {
        if (res === '未開啟攝影機') {
          this.userCheckWebCamAuthority = true
          this.notOpenWebCam = true
        } else {
          this.webCamIsReady = true
          this.userCheckWebCamAuthority = true
          setTimeout(() => {
            this.$refs.webcam.getPicture()
          }, 1000)
        }
      }).catch((e) => {
        console.log(e)
      })
      this.getIdCard()
      this.showNFCBarcode = false
    },
    // [共用] 關閉彈窗時的回調，資料初始化
    closeDialog () {
      console.log('closeeeee')
      // 關閉彈窗時也順便關閉 loading，避免殘留
      if (this.fullScreenLoadingInstance) {
        this.fullScreenLoadingInstance.close()
        this.fullScreenLoadingInstance = null
        this.fullScreenLoadingCount = 0
      }
      this.$refs.webcam.closeWebcam()
      this.requestData = {
        carrierCode: '',
        webcamImageUrl: '',
        idCardId: ''
      }
      this.mode = 0
      this.guestId = ''
      this.webCamIsReady = false
    },
    // [共用] 取得押件清單
    getIdCard () {
      apiGuest.PlusGuestReservation.GetIdCard().then((res) => {
        if (res.status === 200) {
          this.options = [{
            value: '',
            label: '請選擇'
          }]
          res.data.forEach(item => {
            this.options.push({
              value: item.Id,
              label: item.Name
            })
          })
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // [共用] alert視窗
    alert (errTxt) {
      this.$alert(errTxt, '錯誤', {
        confirmButtonText: '確定',
        type: 'error'
      }).then(() => {
        if (this.mode3) {
          window.opener = null
          window.close()
        }
      }).catch(() => {})
      this.fullScreenLoading(false)
      this.dialogVisible = false
    },
    // WebCam拍照後回調函式
    takephoto (url) {
      this.requestData.webcamImageUrl = url
    },
    fullScreenLoading (display) {
      if (display) {
        // 已經有 instance 時只累計計數，不再重複建立
        if (!this.fullScreenLoadingInstance) {
          this.fullScreenLoadingInstance = this.$loading({
            lock: true,
            text: '資料處理中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
        }
        this.fullScreenLoadingCount += 1
      } else {
        if (!this.fullScreenLoadingInstance) return
        this.fullScreenLoadingCount -= 1
        if (this.fullScreenLoadingCount <= 0) {
          this.fullScreenLoadingInstance.close()
          this.fullScreenLoadingInstance = null
          this.fullScreenLoadingCount = 0
        }
      }
    }
  }
}
</script>
<style lang="sass" scoped>
#GuestArriveDialog_main
  ::v-deep .el-dialog
    &.GuestArriveDialog_dialog
      +basicDialog
      min-width: 860px
      .title
        color: $mainFontColor
        font-size: map-get($fontSize,large)
        font-weight: bold
        line-height: 32px
      .tip
        color: $mainColor
        line-height: 20px
        margin-left: 10px
      .el-dialog__body
        display: flex
        padding: 10px 40px
        height: 420px
        .left
          flex: 1
          padding-top: 30px
          border-right: $borderDark1 1px solid
          .el-form
            text-align: left
            margin-bottom: 30px
            .el-form-item
              width: 100%
              margin-bottom: 15px
              .el-select
                width: 90%
          .el-button.disabled
            opacity: 0.3
            cursor: default
        .right
          flex: 1
          position: relative
          .webcamDiv
            left: 0
          .webcamTip
            margin: 0px auto
            width: 260px
            height: 420px
            padding-top: 160px
            p
              &:nth-child(1)
                font-size: 20px
              &:nth-child(2)
                font-size: 16px
                font-weight: bold
                line-height: 40px
      .el-dialog__footer
        text-align: center
</style>
<style lang="sass">
.message-box-alert
  +alert
</style>
